<template>
  <div class="topbar-container">
    <div class="logo-box">
      <img :src="require('../assets/img/logo-white.svg')" alt="Arnergy Logo" />
    </div>
    <div class="right-box">
      <p class="help-text">
        For help please call us on <span class="bolden">07002288888</span>/<span
          class="bolden"
          >08002288888</span
        >
        or email us at <span class="bolden">support@arnergy.com</span>
      </p>
      <div class="v-divider"></div>
      <div class="user-details">
        <p class="name bolden">
          {{
            this.getUserSession !== null
              ? this.getUserSession.firstname +
                " " +
                this.getUserSession.lastname.toUpperCase()
              : ""
          }}
        </p>
        <p class="email sub-text">
          {{ this.getUserSession !== null ? this.getUserSession.email : "" }}
        </p>
      </div>
      <img
        :src="require('../assets/img/logout.svg')"
        alt="Logout button"
        :style="{ cursor: 'pointer' }"
        @click="logout"
      />
      <a
        class="faq"
        href="https://onboarding-faq.netlify.app/homepage/"
        target="_blank"
        >Need Help?</a
      >
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import router from "../router";

export default {
  name: "OnboardingTopBar",
  computed: {
    ...mapGetters(["getUserSession"])
  },
  data() {
    return {
      showDropdown: false
    };
  },
  methods: {
    ...mapActions(["setUserSession"]),
    logout() {
      this.setUserSession(null);
      setTimeout(() => {
        router.push("/auth/login");
      }, 100);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_reduced_variables.scss";

h1,
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

.faq {
  margin-left: 20px;
  border: none;
  background: #0892d0;
  color: #ffffff;
}

.topbar-container {
  height: 100px;
  background: #0892d0;
  color: #ffffff;
  display: flex;
  align-items: center;
  padding: 33px 70px;
  justify-content: space-between;
  margin-bottom: 30px;
}



.logo-box img {
  max-width: 160px;
}

.right-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  font-size: 16px;
  /* flex: 1; */
}

.right-box .help-text {
  width: 45%;
  text-align: right;
  margin-right: 40px;
  line-height: 22px;
}

.bolden {
  font-weight: 700;
}

.v-divider {
  height: 100%;
  border-left: 1px solid rgba(255, 255, 255, 0.5);
  /* border-left: 1px solid rgba($color: #FFFFFF, $alpha: 0.5); */
  margin-right: 40px;
}

.user-details {
  margin-right: 60px;
}

.user-details .sub-text {
  font-size: 12px;
  line-height: 16px;
}

@media screen and (max-width: 430px) {
  .topbar-container {
    padding-left: 2rem;
  }

  .user-details, .help-text {
    display: none;
}

.v-divider {
  margin-left: 4rem;
}

}
</style>



// WEBPACK FOOTER //
// src/components/OnboardingTopBar.vue